"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const React = __importStar(require("react"));
const Inputs_1 = __importDefault(require("./Inputs"));
const Results_1 = __importDefault(require("./Results"));
const search_1 = require("../search");
class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            source: props.defaults.xmlstring,
            xmldoc: props.defaults.xmldoc,
            expression: props.defaults.expression,
            result: []
        };
        this.changeExpression = this.changeExpression.bind(this);
        this.changeXML = this.changeXML.bind(this);
    }
    changeExpression(newExpression) {
        this.setState(state => search_1.searchNewExpression(state, newExpression));
    }
    changeXML(newXML) {
        this.setState(state => search_1.searchNewXML(state, newXML));
    }
    render() {
        return React.createElement("div", { className: 'container' },
            React.createElement(Inputs_1.default, { expression: this.state.expression, document: this.state.source, changeExpression: this.changeExpression, changeXML: this.changeXML }),
            React.createElement("hr", null),
            React.createElement(Results_1.default, { nodes: this.state.result }));
    }
}
exports.App = App;
